import React, { Component } from 'react';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerContractDetails.css';
import { TextField, TabControl } from 'component-lib';
import { DateTimeHelper,CurrencyConverter } from 'utils-lib';
import {ContractDetailsModel, RequestAjaxClass } from 'models-lib';

var moment = require('moment');
moment().format();
class CustomerContractDetails extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.ContractDetailsModel = new ContractDetailsModel([this]);
        this.GetRequest = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null); 
    }

    componentWillMount(){
        this.GetRequest.setApiUrl(Vas.ApiUrl);
        this.GetRequest.setApiKey(Vas.ApiKey);
        this.GetRequest.setAuth(true);
        this.GetRequest.setErrorHandler(()=>{
            $("#LoadingIcon").removeClass().addClass('hide');
        });
        this.ContractDetailsModel.SetRequest(this.GetRequest);
    }

    componentDidMount(){
        let me = this;
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.ContractDetailsModel.GetContractDetailsByContractId(me.props.Id);
    }

    Update(observer)
    {
      let me = this;
        this.setState({},()=>{
          if(observer === "ContractDetails"){
            $("#LoadingIcon").removeClass().addClass('hide');
            if(me.refs)
            {

              me.refs.ContractStart.setState({ Value: me.ContractDetailsModel.Contract.DateFrom });

              let contractEnd = me.ContractDetailsModel.Contract.DateTo;
              let contractEndDate = DateTimeHelper.StringToDate(contractEnd,false,localStorage.getItem('vas_language'));
              if( contractEndDate.isBefore(moment([1900,0,1])) === true){
                contractEnd = Vas.Resources.Labels["Unlimited"];
              }
              me.refs.ContractEnd.setState({ Value: contractEnd });

              if(me.ContractDetailsModel.Contract.StatusId === 10){
                me.refs.State.setState({ Value:Vas.Resources.Labels["PendingApproval"] });
              }else{
                me.refs.State.setState({ Value:me.ContractDetailsModel.Contract.Status }); 
              }

              me.refs.ContractNumber.setState({ Value: me.ContractDetailsModel.Contract.ContractNumber });
              me.refs.NameOfBank.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.BankName : "" });
              me.refs.Iban.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.Iban: "" });
              me.refs.Bic.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.Bic: "" });
              me.refs.Depositor.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.AccountOwner : "" });
              me.refs.From.setState({ Value: me.ContractDetailsModel.ContractConnection.From });
              me.refs.To.setState({ Value: me.ContractDetailsModel.ContractConnection.To });
              me.refs.Via.setState({ Value: me.ContractDetailsModel.ContractConnection.Via });
              me.refs.StopFrom.setState({ Value: me.ContractDetailsModel.ContractConnection.StopFrom });
              me.refs.StopTo.setState({ Value: me.ContractDetailsModel.ContractConnection.StopTo });
              me.refs.ProductPrice.setState({ Value: CurrencyConverter.Cast( me.ContractDetailsModel.ContractPrice.Price, localStorage.getItem("vas_language") ,2) });
              me.refs.PriceLevel.setState({ Value: me.ContractDetailsModel.ContractPrice.PriceLevel });
              me.refs.Share1.setState({ Value:me.ContractDetailsModel.Share1 });
              me.refs.Share2.setState({ Value:me.ContractDetailsModel.Share2 });
            }
          }
        });
    }

    render()
    {         
        return (
          <div>
            <table style={{ width:'100%' }}>
              <tbody>
                <tr>
                  <td><TabControl
                    Id={"Details"} 
                    Content={[
                      { Title:Vas.Resources.Labels["ContractData"],Content:<table>
                        <tbody>
                          <tr>
                            <td><TextField 
                              ref={"ContractNumber"} 
                              AppURL={Vas.ApplicationUrl} 
                              Label={Vas.Resources.Labels["ContractNumber"]} 
                              Editable={false} />
                            </td>
                            <td><TextField 
                              ref={"ProductPrice"} 
                              AppURL={Vas.ApplicationUrl} 
                              Label={Vas.Resources.Labels["ProductPrice"]} 
                              Editable={false} />
                            </td>

                          </tr>
                          <tr>
                            <td><TextField 
                              ref={"PriceLevel"} 
                              AppURL={Vas.ApplicationUrl} 
                              Label={Vas.Resources.Labels["PriceLevel"]} 
                              Editable={false} />
                            </td>
                            <td><TextField 
                              ref={"State"} 
                              AppURL={Vas.ApplicationUrl} 
                              Label={Vas.Resources.Labels["State"]} 
                              Editable={false} /> 
                            </td>
                          </tr>
                          <tr>
                            <td><TextField 
                              ref={"ContractStart"} 
                              AppURL={Vas.ApplicationUrl} 
                              Label={Vas.Resources.Labels["ContractStart"]} 
                              Editable={false} />
                            </td>
                            <td><TextField 
                              ref={"ContractEnd"} 
                              AppURL={Vas.ApplicationUrl} 
                              Label={Vas.Resources.Labels["ContractEnd"]} 
                              Editable={false} />
                            </td>
                          </tr>
                          <tr>
                            <td><TextField 
                              ref={"Share1"} 
                              AppURL={Vas.ApplicationUrl} 
                              Label={Vas.Resources.Labels["Share1"]} 
                              Editable={false} />
                            </td>
                            <td><TextField 
                              ref={"Share2"} 
                              AppURL={Vas.ApplicationUrl} 
                              Label={Vas.Resources.Labels["Share2"]} 
                              Editable={false} />
                            </td>
                          </tr>
                        </tbody>
                      </table> },
                      { Title:Vas.Resources.Labels["ConnectionData"],Content:<table><tbody><tr>
                        <td><TextField 
                          ref={"From"} 
                          AppURL={Vas.ApplicationUrl} 
                          Label={Vas.Resources.Labels["From"]} 
                          Editable={false} />
                        </td>
                        <td><TextField 
                          ref={"To"} 
                          AppURL={Vas.ApplicationUrl} 
                          Label={Vas.Resources.Labels["To"]} 
                          Editable={false} />
                        </td>
                      </tr>
                        <tr>
                          <td><TextField 
                            ref={"Via"} 
                            AppURL={Vas.ApplicationUrl} 
                            Label={Vas.Resources.Labels["Via"]} 
                            Editable={false} />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}><TextField 
                            ref={"StopFrom"} 
                            AppURL={Vas.ApplicationUrl} 
                            Label={Vas.Resources.Labels["StopFrom"]} 
                            Editable={false} 
                            Width={346} />
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}><TextField 
                            ref={"StopTo"} 
                            AppURL={Vas.ApplicationUrl} 
                            Label={Vas.Resources.Labels["StopTo"]} 
                            Editable={false} 
                            Width={346} />
                          </td>
                        </tr>
                      </tbody>
                      </table> },
                      { Title:Vas.Resources.Labels["DefaultMethodOfPayment"],Content:<table><tbody><tr>
                        <td><TextField 
                          ref={"Depositor"} 
                          AppURL={Vas.ApplicationUrl} 
                          Label={Vas.Resources.Labels["Depositor"]} 
                          Editable={false} />
                        </td>
                        <td><TextField 
                          ref={"NameOfBank"} 
                          AppURL={Vas.ApplicationUrl} 
                          Label={Vas.Resources.Labels["NameOfBank"]} 
                          Editable={false} />
                        </td>

                      </tr>
                        <tr>
                          <td><TextField 
                            ref={"Iban"} 
                            AppURL={Vas.ApplicationUrl} 
                            Label={Vas.Resources.Labels["Iban"]} 
                            Editable={false} /> 
                          </td>
                          <td><TextField 
                            ref={"Bic"} 
                            AppURL={Vas.ApplicationUrl} 
                            Label={Vas.Resources.Labels["Bic"]} 
                            Editable={false} /> 
                          </td>
                        </tr>
                      </tbody>
                      </table> }]} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default CustomerContractDetails;
